<template lang="pug">
	.geo-targets-list
		MapSelector(
			v-bind="$props",
			ref="geoTargets",
			:disabled="!project",
			:geoJsonDrawings="geoJsonDrawings",
			@select-target="v => selectedGeoTargetPlace = v",
			@resize="v => innerHeight = v",
			@create="v => linkUnlinkTargets([v.Oid])",
			@place-changed="selectedExistingGeoTargets = []"
			@update="v => linkUnlinkTargets([v.Oid])"
			@clearTargetPlace="clearTargetPlace"
		)
			.flex-col.space
				ListView.full-width(
					ref="targetsListView",
					initialView="table",
					:disabled="isGeoEditing",
					:height="height || (innerHeight - 20)",
					:searchVisible="!!project",
					:showColumnHeaders="false",
					:topPagerVisible="false",
					:hideViewsSelection="true",
					:getTotal="(r) => r.TotalNumberOfRecords",
					:getItems="(r) => r.Results",
					:getData="loadProjectTargets",
					:noDataText="!project ? $tCaption('Please, select or create project') : null",
					:columns="[{ dataField: 'Name', cellTemplate: 'displayTemplate' }]", valueExpr="Oid",
					:selectedRowKeys="selectedRowKeys",
					:selectionMode="selectionMode || 'single'",
					@selection="onSelect"
				)
					template(v-slot:displayTemplate="{ data }")
						.flex-col
							.flex-row.justify.space.align-center
								.flex-row.space.align-center
									.target-name.overflow(:title="data.Name") {{data.Name}}
									slot(name="target-header", :target="data")
								.actions.flex-row.space
									.ui-button.hover.scale.align-center.center.flex-row(
										v-if="data.IsUserDefined",
										:class="{'disabled': isGeoEditing}",
										@click="!isGeoEditing ? onEditGeoTarget(data) : null",
									)
										i.fas.fa-edit
									.ui-button.hover.scale.align-center.center.flex-row(
										v-if="!disableRemove",
										:class="{'disabled': isGeoEditing}",
										@click="() => isGeoEditing ? data.IsUserDefined ? removeGeoTarget(data.Oid) : linkUnlinkTargets([data.Oid], true) : null",
									)
										i.fas.fa-times
							.target-info.flex-row.space-large.grey.font-small(v-if="data.Radius")
								.flex-row.space
									span {{$tCaption('Radius')}}
									span {{cartoApi.getRadiusDividedValue(data.Radius)}} {{kmOrMiles}}
								.flex-row.space
									span {{$tCaption('Lat')}}
									span {{data.Lat}}
								.flex-row.space
									span {{$tCaption('Lng')}}
									span {{data.Lng}}
					.flex-row.space.align-center(slot="left-actions")
						.flex-row.space.justify
							Dropdown.flex-1(
								ref="projectsDD",
								:getTotal="(data) => null",
								:getItems="(data) => data.Results",
								:getData="$Data.getTargetProjects",
								:columns="projectDDColumns",
								displayExpr="Name",
								valueExpr="Oid",
								:placeholder="$tCaption('Project')",
								:selectedItems="project && project.Oid",
								:showColumnHeaders="false",
								:filtersVisible="false",
								:searchVisible="true",
								:multiple="false",
								:disabled="!!isLoading || isGeoEditing",
								:width="160",
								@select-data="item => project = item")
								template(v-slot:actionsTemplate="{ data }")
									DxButton(
										icon="trash",
										type="danger",
										stylingMode="text",
										:disabled="isLoading",
										@click="e => { e.event.stopPropagation(); removeProject(data.Oid); }"
									)
							DxButton.small(
								:title="$tCaption('New project')",
								icon="fas fa-plus",
								stylingMode="text"
								:disabled="isLoading || isGeoEditing",
								@click="initNewProject"
							)
		Popup(
			:popupVisible="newProject.visible"
			:width="280",
			:height="220",
			:title="$tCaption('New project')",
			:closeOnOutsideClick="false",
			@hiding="newProject.visible = false"
		)
			.flex-col.field
				.font-small.upper.grey {{$tCaption('Project name')}}
				DxTextBox(
					:value.sync="newProject.name",
					valueChangeEvent="keyup"
				)
			template(slot="actions-right")
				DxButton(
					:text="$tCaption('OK', '@actions')",
					type="default",
					:disabled="!newProject.name || isLoading"
					@click="createNewProject",
				)
				DxButton(
					:text="$tCaption('Cancel', '@actions')",
					@click="newProject.visible = false"
				)
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import ListView from 'app-core/ListView.vue';
	import api from 'view/carto/api.js';
	import MapSelector from './MapSelector.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import Popup from 'app-core/Popup.vue';
	import wkt from 'wicket';

	export default {
		translationCategory: 'geoTargets.List',
		name: 'geo-targets',
		props: [
			'processSelection',
			'selectedRowKeys',
			'selectionMode',
			'placeResolver',
			'saveResolver',
			'disableRemove',
			'height',
			'insertionId',
		],
		components: {
			DxButton,
			DxNumberBox,
			DxTextBox,
			ListView,
			MapSelector,
			Dropdown,
			Popup,
		},
		data() {
			return {
				isLoading: false,
				innerHeight: 300,
				selectedGeoTargetPlace: null,
				project: null,
				newProject: {
					name: null,
					visible: false
				},
				projectDDColumns: [
					{
						dataField: 'Name',
						caption: this.$tCaption('Project')
					},
					{
						dataField: 'Name',
						name: 'Name1',
						caption: '',
						cellTemplate: 'actionsTemplate',
						width: '80px'
					}
				],
				selectedExistingGeoTargets: [],
				isGeoEditing: false,
			}
		},
		computed: {
			cartoApi() {
				return api;
			},
			kmOrMiles() {
				return api.kmOrMiles();
			},
			geoJsonDrawings() {
				let wktObject = new wkt.Wkt();
				return this.selectedExistingGeoTargets
					.filter(f => f.GeoPolygonWkt)
					.map(f => {
						let geoJson = wktObject.read(f.GeoPolygonWkt);
						return geoJson.toJson();
					});
			},
		},
		watch: {
			project() {
				this.updateTargetsList();
				this.selectedExistingGeoTargets = [];
			}
		},
		mounted() {
			if (__DEBUG__) {
				window.geoTargetsList = this;
				window.wiket = wkt;
			}
		},
		destroyed() {
			if (this.$unobserve)
				this.$unobserve();
			delete this.$unobserve;
		},
		methods: {
			loadProjectTargets(pageIndex, limit, opts) {
				return !this.project
					? Promise.resolve({ Results: [] })
					: this.$Data.getTargetProjectLinkedGeoTargets(pageIndex, limit, opts, this.project?.Oid);
			},
			initNewProject() {
				this.newProject.name = null;
				this.newProject.visible = false;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.newProject.visible = true;
				});
			},
			createNewProject() {
				this.isLoading = true;
				this.$Data
					.postExternalApi('TargetProject/CreateUpdateTargetProject', {
						Oid: null,
						Name: this.newProject.name
					})
					.then(r => {
						if (r.Success) {
							this.$notifySuccess(this.$tCaption('Project has been created.'));
							this.project = r.Data;
							this.$refs.projectsDD?.reload();
						}
					})
					.finally(() => {
						this.newProject.visible = false;
						this.isLoading = false;
					});
			},
			removeProject(projectId) {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to delete this project?'),
					handler: async () => {
						this.isLoading = true;
						this.$Data.postExternalApi('TargetProject/DeleteTargetProjectByIds', [projectId])
							.then(() => {
								this.$refs.projectsDD?.reload();
								if (this.project?.Oid === projectId) {
									this.project = null;
								}
							})
							.finally(() => this.isLoading = false);
					}
				});
			},
			removeGeoTarget(targetId) {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to delete this geo target?'),
					buttons: [
						{
							type: 'danger',
							text: this.$tCaption('Delete from all projects'),
							onClick: () => {
								this.isLoading = true;
								this.$Data.getExternalApi('Target/DeleteTarget', `targetId=${targetId}`).then((r) => {
									if (r.Success) {
										this.selectedGeoTargetPlace = null;
										this.$notifySuccess(this.$tCaption('Geo target deleted'), 'success', 600);
										this.updateTargetsList();
										this.$emit('remove', targetId, r);
									}
								}).finally(() => this.isLoading = false);
							}
						},
						{
							type: 'success',
							text: this.$tCaption('Unlink'),
							onClick: () => {
								this.linkUnlinkTargets([targetId], true, true);
							}
						},
						{
							text: this.$tCaption('Cancel', '@actions'),
							onClick: () => {
								return false;
							}
						},
					]
				});
			},
			onSelect(items, selectionInfo) {
				if (this.processSelection)
					this.processSelection(items, selectionInfo);
				this.selectedExistingGeoTargets = items;
			},
			onEditGeoTarget(target) {
				this.selectedExistingGeoTargets = [target];
				this.$refs.geoTargets.setEditingGeoTarget(this.lowerCaseKeys(target));
				this.isGeoEditing = true;
			},
			updateTargetsList() {
				this.$refs.targetsListView?.reload();
			},
			linkUnlinkTargets(targetIds, unlink, silent) {
				this.isLoading = true;
				return new Promise(res => {
					let exec = () => this
						.$Data
						.postExternalApi(
							'TargetProject/LinkUnlinkTargets',
							{
								TargetObjectId: this.project?.Oid,
								RelatedObjectIds: targetIds,
								IsLinkAction: !unlink
							},
						)
						.then((r) => {
							if (r.Success) {
								this.$notifyWarning(
									this.$tCaption(unlink
										? 'Geo-target removed from the project'
										: 'Geo-target added to the project')
								);
							}
							this.updateTargetsList();
							return r;
						})
						.finally(() => this.isLoading = false);

					if (silent || !unlink) {
						res(exec());
					} else {
						this.$confirmMessage({
							title: this.$tCaption('Confirm action', '@actions'),
							text: this.$tCaption('Are you sure you want to remove this geo target?'),
							handler: async () => {
								res(exec());
							}
						});
					}
				});
			},
			clearTargetPlace() {
				this.isGeoEditing = false;
			},
			lowerCaseKeys(obj) {
				if (typeof obj !== 'object' || obj === null) return obj;
				if (Array.isArray(obj)) return obj.map(o => this.lowerCaseKeys(o));

				return Object
					.keys(obj)
					.reduce((acc, key) => {
						acc[key[0].toLowerCase() + key.slice(1)] = this.lowerCaseKeys(obj[key]);
						return acc;
					}, {});
			},
		}
	};
</script>

<style lang='scss'>
	.geo-targets-list {
		padding: 4px;
	}
</style>
